const map = {
	"./ablobgift.gif": 61248,
	"./arrow2_n.png": 8113,
	"./arrow2_s.png": 29908,
	"./blobgift.png": 83926,
	"./danbirthday.png": 20067,
	"./danbooru-logo-128x128.png": 31782,
	"./danbooru-logo-500x500.png": 96578,
	"./danbooru-logo-96x96.png": 44296,
	"./flash-preview.png": 30284,
	"./halloween-logo-128x128.png": 26577,
	"./icons.svg": 12172,
	"./kemogift.png": 62739,
	"./padoru.gif": 35175,
	"./provgift.png": 17106,
	"./ui-icons_777777_256x240.png": 55373
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10452;